import {
    Deferred,
    Instance,
    Objekt,
    Promize,
    Table,
} from '@siposdani87/sui-js';
import { app } from '../app';
import { AssetService } from '@services/assetService';
import { LanguageService } from '@services/languageService';
import { LicenseService } from '@services/licenseService';
import { OrganizationService } from '@services/organizationService';
import { initTable } from '@utils/collectionSetup';
import { DashboardController } from './dashboardController';

export class LicensesIndexByOrganizationController extends DashboardController {
    static readonly inject = [
        'instances',
        'licenseService',
        'organizationService',
        'assetService',
        'languageService',
    ] as const;

    organizationId!: string;
    organization!: Objekt;
    licensesTable!: Table;

    constructor(
        instances: Instance,
        private licenseService: LicenseService,
        private organizationService: OrganizationService,
        private assetService: AssetService,
        private languageService: LanguageService,
    ) {
        super(instances);
    }

    protected override _initLayout(): void {
        this.organizationId = this.state.getParam('organizationId');
        this.organization = new Objekt();

        this._initToolbarButtons();

        this._loadOrganization().then(() => {
            this._drawContent();
        });
    }

    protected override _drawContent(): Promize | boolean {
        this._initLicenseTable();
        return true;
    }

    private _loadOrganization(): Promize {
        const deferred = new Deferred();
        this.organizationService
            .get(this.organizationId, {
                fields: 'id',
            })
            .then(
                (response) => {
                    this.organization = response.get<Objekt>('organization');
                    deferred.resolve();
                },
                () => {
                    deferred.reject();
                },
            );
        return deferred.promise();
    }

    private _initLicenseTable(): void {
        this.licensesTable = initTable(
            this.licensesTable,
            this.dom,
            'table',
            this.licenseService,
            {
                entityKey: 'licenses',
                fetchData: (params) =>
                    this.licenseService.getAllByOrganization(
                        this.organizationId,
                        params,
                    ),
            },
        )!;
    }

    private _initToolbarButtons(): void {
        this.helper.fabButton('.btn-orders-new', this.dom, () => {
            this.state.go('orders.new', {
                organizationId: this.organizationId,
            });
        });

        this.helper.iconButton('.btn-organizations-show', this.dom, () => {
            this.state.goBack('organizations.show', {
                organizationId: this.organizationId,
            });
        });
    }
}

export const licensesIndexByOrganizationController = app.controller(
    'licensesIndexByOrganizationController',
    LicensesIndexByOrganizationController,
);
